import { TODO, request, success, failure } from "./utilities";
import {
  fetchTodos,
  createTodo,
  removeTodo,
  allUserTodo,
  compTodo,
  editToDo,
  postTodoCommentAPI,
  loadWorkProgress_API,
  addTodoFlag_API,
  getLoggedHoursGraphDataApi,
  getTaskHourComparisonByEmpApi,
  getEmployeeRankingOnLoggedHoursApi,
  getEmployeeTasksGraphApi,
  getAllUserToDoApi,
  getEmpTodoTaskListApi,
  getAllUserToDoListApi,
} from "../api";
import {
  todosUsers,
  todoUsersDummyData,
} from "../../requestDTO/Todos/TodoUsersDTO";
import {
  todoLists,
  todoListsDummyData,
} from "../../requestDTO/Todos/TodoListsDTO";
import { GetRequest, PostRequest } from "../api/genericApiCalls";
import { APP_SETTINGS } from "../../config";
import { Notification } from "../../assets";

export function getEmployees(userData, info, token) {
  return (dispatch) => {
    //dispatch(request(TODO.TODO_MESSAGES_RESET));
    dispatch(request(TODO.GET_TODO_EMPLOYEES_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.TODO.getToDoEmployees,
      userData,
      token
    ).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.GET_TODO_EMPLOYEES_SUCCESS, res.data.data, info)
          );
        } else {
          dispatch(failure(TODO.GET_TODO_EMPLOYEES_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_TODO_EMPLOYEES_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getEmployeeTodos(reqObject, token) {
  return (dispatch) => {
    dispatch(request(TODO.GET_TODO_REQUEST, reqObject.EmployeeId));
    PostRequest(
      APP_SETTINGS.API_PATH.TODO.getEmployeeTodos,
      reqObject,
      token
    ).then(
      (res) => {
        // console.log("employeetodos resp", res);
        if (res.data.status == 1) {
          dispatch(success(TODO.GET_TODO_SUCCESS, res.data.data));
        } else {
          dispatch(failure(TODO.GET_TODO_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_TODO_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

// this is currently being used by workload screen, once structure is finallized we will remove this duplicate method from here
export function getTodos(userData, token) {
  return (dispatch) => {
    //dispatch(request(TODO.TODO_MESSAGES_RESET));
    dispatch(request(TODO.GET_TODO_REQUEST));
    // console.log("todoUsersDummyData", todoUsersDummyData);
    dispatch(success(TODO.GET_TODO_SUCCESS, todoUsersDummyData));
    fetchTodos(userData, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(TODO.GET_TODO_SUCCESS, res.data.data));
        } else {
          dispatch(failure(TODO.GET_TODO_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_TODO_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function deleteTodoAction(reqObject, infoObject, token) {
  return (dispatch) => {
    dispatch(request(TODO.DELETE_TODO_REQUEST));

    return PostRequest(APP_SETTINGS.API_PATH.TODO.deleteToDo, reqObject, token)
      .then((res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.DELETE_TODO_SUCCESS, res.data.data, infoObject)
          );
          return Promise.resolve();
        } else {
          dispatch(failure(TODO.DELETE_TODO_FAILURE, res.data.message));
          return Promise.reject(res.data.message);
        }
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.title || error.message;
        dispatch(failure(TODO.DELETE_TODO_FAILURE, errorMessage));
        return Promise.reject(errorMessage);
      });
  };
}

export function updateTodo(userData, token, errorNoti, moveToNext) {
  return (dispatch) => {
    dispatch(request(TODO.EDIT_TODO_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.TODO.editToDo, userData, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(TODO.EDIT_TODO_SUCCESS, res.data.data));
          if (errorNoti) {
            errorNoti(res.data.message, "success");
          }
          dispatch(success(TODO.ADD_TODO_SUCCESS, res.data.data));
          if (moveToNext) {
            moveToNext();
          }
        } else {
          dispatch(failure(TODO.EDIT_TODO_FAILURE, res.data.message));
          if (errorNoti) {
            errorNoti(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.EDIT_TODO_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function addToDo(userData, token, errorNoti, moveToNext) {
  return (dispatch) => {
    dispatch(request(TODO.ADD_TODO_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.TODO.addToDo, userData, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(TODO.ADD_TODO_SUCCESS, res.data.data));
          if (moveToNext) {
            moveToNext();
          }
          if (errorNoti) {
            errorNoti(res.data.message, "success");
          }
        } else {
          dispatch(failure(TODO.ADD_TODO_FAILURE, res.data.message));
          if (errorNoti) {
            errorNoti(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.ADD_TODO_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function completeTodoAction(reqObject, infoObject, token, Notification) {
  return (dispatch) => {
    dispatch(request(TODO.COMPLETE_TODO_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.TODO.completeToDo, reqObject, token)
      .then((res) => {
        // Dispatch the success action with returned data and info
        dispatch(
          success(TODO.COMPLETE_TODO_SUCCESS, res.data.data, infoObject)
        );

        // Show the notification coming from the response (call directly, not via dispatch)
        if (res.data && res.data.message) {
          Notification(res.data.message, "success");
        }

        // "Move to Next" functionality: reload the todo list via second API
        const data = { userId: infoObject.employeeId };
        dispatch(getUserToDosAction(data, token));
      })
      .catch((error) => {
        const errorMsg =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.title
            ? error.response.data.title
            : error.message;
        dispatch(failure(TODO.COMPLETE_TODO_FAILURE, errorMsg));

        // Show the error notification (call directly, not via dispatch)
        Notification(errorMsg, "error");
      });
  };
}

export function getAllUserTodo(userData, token) {
  // console.log("Get All User todo");
  return (dispatch) => {
    dispatch(request(TODO.GETALLUSER_TODO_REQUEST));
    allUserTodo(userData, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(TODO.GETALLUSER_TODO_SUCCESS, res.data.data));
        } else {
          dispatch(failure(TODO.GETALLUSER_TODO_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GETALLUSER_TODO_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function SaveCommentAction(reqObject, token, indexInfo) {
  return (dispatch) => {
    dispatch(request(TODO.POST_TODO_COMMENT_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.TODO.todoComment, reqObject, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.POST_TODO_COMMENT_SUCCESS, res.data.data, indexInfo)
          );
        } else {
          dispatch(failure(TODO.POST_TODO_COMMENT_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.POST_TODO_COMMENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function DeleteCommentAction(commentId, info, token) {
  // console.log("commentid22", commentId);
  return (dispatch) => {
    dispatch(request(TODO.DELETE_TODO_COMMENT_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.TODO.todoDeleteComment}?commentId=${commentId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.DELETE_TODO_COMMENT_SUCCESS, res.data.data, info)
          );
        } else {
          dispatch(failure(TODO.DELETE_TODO_COMMENT_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.DELETE_TODO_COMMENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function loadWorkProgressAaction(reqObject, token, req) {
  return (dispatch) => {
    dispatch(request(TODO.LOAD_WORK_PROGRESS_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.TODO.getWorkProgress,
      reqObject,
      token
    ).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(TODO.LOAD_WORK_PROGRESS_SUCCESS, res.data.data));
        } else {
          dispatch(failure(TODO.LOAD_WORK_PROGRESS_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.LOAD_WORK_PROGRESS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function addTodoFlagAction(reqObject, infoObject, token) {
  return (dispatch) => {
    dispatch(request(TODO.ADD_TODO_FLAG_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.TODO.todoFlag, reqObject, token).then(
      (res) => {
        // console.log("add todo flag response :::", res);
        if (res.data.status === 1) {
          dispatch(
            success(TODO.ADD_TODO_FLAG_SUCCESS, res.data.data, infoObject)
          );
        } else {
          dispatch(failure(TODO.ADD_TODO_FLAG_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.ADD_TODO_FLAG_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getCommentsAction(taskId, infoObject, token) {
  // console.log("get comments api called", taskId);
  return (dispatch) => {
    dispatch(request(TODO.GET_TODO_COMMENT_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.TODO.getTodoComments}?taskId=${taskId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.GET_TODO_COMMENT_SUCCESS, res.data.data, infoObject)
          );
        } else {
          dispatch(failure(TODO.GET_TODO_COMMENT_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_TODO_COMMENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getTaskCategoriesAction(taskId, infoObject, token) {
  return (dispatch) => {
    dispatch(request(TODO.GET_TASK_CATEGORIES_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.TODO.getTodoComments}?taskId=${taskId}`;
    PostRequest(path, null, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.GET_TASK_CATEGORIES_SUCCESS, res.data.data, infoObject)
          );
        } else {
          dispatch(failure(TODO.GET_TASK_CATEGORIES_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_TASK_CATEGORIES_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function DayPlannerTodoTimeLogAction(req, token, onSuccess, employeeId) {
  return (dispatch) => {
    dispatch(request(TODO.ADD_TODO_LOG_TIME_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.TASK.postTaskWorkLog, req, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.ADD_TODO_LOG_TIME_SUCCESS, res.data.data, employeeId)
          );
          onSuccess();
        } else {
          dispatch(failure(TODO.ADD_TODO_LOG_TIME_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.ADD_TODO_LOG_TIME_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getLoggedHoursGraphData(reqObject, token) {
  return (dispatch) => {
    dispatch(request(TODO.GET_LOGGED_HOUR_GRAPH_DATA_REQUEST));
    getLoggedHoursGraphDataApi(reqObject, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.GET_LOGGED_HOUR_GRAPH_DATA_SUCCESS, res.data.data)
          );
        } else {
          dispatch(
            failure(TODO.GET_LOGGED_HOUR_GRAPH_DATA_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_LOGGED_HOUR_GRAPH_DATA_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function getAllUserToDoAction(reqObject) {
  return (dispatch) => {
    dispatch(request(TODO.GET_ALL_HOME_USER_TODO_REQUEST));
    getAllUserToDoApi(reqObject).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(TODO.GET_ALL_HOME_USER_TODO_SUCCESS, res.data.data));
        } else {
          dispatch(
            failure(TODO.GET_ALL_HOME_USER_TODO_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_ALL_HOME_USER_TODO_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getTaskHourComparisonByEmp(reqObject, token) {
  return (dispatch) => {
    dispatch(request(TODO.GET_TASK_HOUR_COMPARISON_BY_EMP_REQUEST));
    getTaskHourComparisonByEmpApi(reqObject, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.GET_TASK_HOUR_COMPARISON_BY_EMP_SUCCESS, res.data.data)
          );
        } else {
          dispatch(
            failure(
              TODO.GET_TASK_HOUR_COMPARISON_BY_EMP_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_TASK_HOUR_COMPARISON_BY_EMP_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getEmployeeRankingOnLoggedHours(reqObject, token) {
  return (dispatch) => {
    dispatch(request(TODO.GET_EMP_RANKING_ON_LOGGED_HOURS_REQUEST));
    getEmployeeRankingOnLoggedHoursApi(reqObject, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.GET_EMP_RANKING_ON_LOGGED_HOURS_SUCCESS, res.data.data)
          );
        } else {
          dispatch(
            failure(
              TODO.GET_EMP_RANKING_ON_LOGGED_HOURS_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_EMP_RANKING_ON_LOGGED_HOURS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getEmployeeTasksGraph(reqObject, token) {
  return (dispatch) => {
    dispatch(request(TODO.GET_EMP_TASKS_GRAPH_REQUEST));
    getEmployeeTasksGraphApi(reqObject, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(TODO.GET_EMP_TASKS_GRAPH_SUCCESS, res.data.data));
        } else {
          dispatch(failure(TODO.GET_EMP_TASKS_GRAPH_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_EMP_RANKING_ON_LOGGED_HOURS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getEmpTodoTaskListAction(data, token) {
  // console.log("Get All User todo");
  return (dispatch) => {
    dispatch(request(TODO.GET_EMP_TODO_TASK_LIST_REQUEST));
    getEmpTodoTaskListApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(TODO.GET_EMP_TODO_TASK_LIST_SUCCESS, res.data.data));
        } else {
          dispatch(
            failure(TODO.GET_EMP_TODO_TASK_LIST_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_EMP_TODO_TASK_LIST_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getUserToDosAction(reqObject, token) {
  return (dispatch) => {
    dispatch(request(TODO.GET_USER_TODOS_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.TODO.getUserToDos, reqObject, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(TODO.GET_USER_TODOS_SUCCESS, res.data.data.todoLists)
          );
        } else {
          dispatch(failure(TODO.GET_USER_TODOS_FAILURE, res.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            TODO.GET_USER_TODOS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
